import prepareOptions from '../../prepareOptions';
import {
  TEN_KMS,
  TWENTY_KMS,
  FIFTY_KMS,
  ONE_HUNDERED_KMS,
  FIVE_HUNDRED_KMS,
} from './values';

export default prepareOptions([
  {
    label: __('search.filters.distance'),
    disabled: true,
  },
  {
    label: __('search.filters.distance.tenKms'),
    value: TEN_KMS,
  },
  {
    label: __('search.filters.distance.twentyKms'),
    value: TWENTY_KMS,
  },
  {
    label: __('search.filters.distance.fiftyKms'),
    value: FIFTY_KMS,
  },
  {
    label: __('search.filters.distance.oneHundredKms'),
    value: ONE_HUNDERED_KMS,
  },
  {
    label: __('search.filters.distance.fiveHundredKms'),
    value: FIVE_HUNDRED_KMS,
  },
]);
